import { BCalendar } from './calendar';
import { pluginFactory } from '../../utils/plugins';
var CalendarPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BCalendar: BCalendar
  }
});
export { CalendarPlugin, BCalendar };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/calendar/index.js
// module id = 166
// module chunks = 0